exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".transfer[data-v-379ac7a9]{position:absolute;height:100%;width:100%;top:0;left:0;background:#fff!important;padding:.3rem}.transfer>div[data-v-379ac7a9]{width:4rem;height:1.6rem;position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);text-align:center}.transfer>div .login-loading[data-v-379ac7a9]{width:1.6rem;height:1.6rem;margin:0 auto}.transfer>div p[data-v-379ac7a9]{line-height:1rem;font-size:.28rem;color:#409eff}", ""]);

// exports
